import { render, staticRenderFns } from "./max_load_detail.vue?vue&type=template&id=7dba0464&"
import script from "./max_load_detail.vue?vue&type=script&lang=js&"
export * from "./max_load_detail.vue?vue&type=script&lang=js&"
import style0 from "./max_load_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports